module.exports = __webpack_public_path__ + "img/logo_emblem.c4641fea.svg";